export default __webpack_public_path__ + "static/media/white-identify-multiple-features-icon.be7f6825.svg";